import { createStore } from '@oneappexchange/lwc-wired-store';
import { IS_DEVELOPMENT } from '~/config';
import { getPaymentRequired } from '../services/securityReviewPaymentService';
const INITIAL_PAYMENT_AMOUNT = 99900;
const initialState = {
  paymentRequired: true,
  paymentCompleted: false,
  processingPayment: false,
  paymentError: false,
  transactionId: '',
  totalAmount: INITIAL_PAYMENT_AMOUNT
};
export const securityReviewPaymentStore = createStore(initialState, set => ({
  async getSRPaymentRequired(solutionId) {
    const responsePayment = await getPaymentRequired(solutionId);
    set(function getSRPaymentRequired(draft) {
      var _session, _session2;
      let paymentType;
      let paymentStatus;
      let session;
      if ((responsePayment === null || responsePayment === void 0 ? void 0 : responsePayment.id) === null) {
        paymentType = responsePayment;
      } else {
        paymentType = responsePayment === null || responsePayment === void 0 ? void 0 : responsePayment.paymentRequirement;
        paymentStatus = responsePayment === null || responsePayment === void 0 ? void 0 : responsePayment.status;
        session = responsePayment === null || responsePayment === void 0 ? void 0 : responsePayment.checkoutSession;
      }
      switch (paymentStatus) {
        case 'failed':
        case 'cancelled':
          draft.paymentError = true;
          draft.paymentCompleted = false;
          draft.processingPayment = false;
          break;
        case 'successful':
        case 'completed':
          draft.paymentCompleted = true;
          draft.transactionId = ((_session = session) === null || _session === void 0 ? void 0 : _session.payment_intent) || '';
          draft.totalAmount = ((_session2 = session) === null || _session2 === void 0 ? void 0 : _session2.amount_total) || 0;
          draft.paymentError = false;
          draft.processingPayment = false;
          break;
        case 'new':
        default:
          draft.paymentCompleted = false;
          draft.paymentError = false;
          draft.processingPayment = false;
      }
      draft.paymentRequired = paymentType === 'payment_required';
    });
  }
}), 'SECURITY_REVIEW_PAYMENT', IS_DEVELOPMENT);
export function selectTotalAmount(state) {
  return state.totalAmount;
}
export function selectPaymentRequired(state) {
  return state.paymentRequired;
}
export function selectPaymentCompleted(state) {
  return state.paymentCompleted;
}
export function processingPayment(state) {
  return state.processingPayment;
}